var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#141B34",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M15.749 19.833h4.083a5.833 5.833 0 1 0 0-11.667h-4.083m-3.5 11.667H8.165a5.833 5.833 0 0 1 0-11.667h4.084M10.5 14h7"
  })));
};
export default SvgLink;